import { LabelInlineIconStyled } from './styled';
import cx from "classnames";

const LabelInlineIcon = ({ icon, label, theme_standard_label_inline_icon, theme_title }) => {
  const customClass = cx({
    theme_standard_label_inline_icon: theme_standard_label_inline_icon,
    theme_title: theme_title,
  });
  return (
    <LabelInlineIconStyled>
      <div className={customClass}>
        {icon && <span className="icon_wrap">{icon}</span>}
        {label && <span className="label_text">{label}</span>}
      </div>
    </LabelInlineIconStyled>
  );
};

export default LabelInlineIcon;
